const MIN_SCALE = 1;
const MAX_SCALE = 5;
const STEP = 1.6;
const DOUBLE_SCALE = 2.5;
const EDGE_GUARD = 56;
const TAP_SLOP = 40;

function initLightbox() {
  const root = document.querySelector('.hd-pdp');
  const dialog = document.querySelector('[data-hd-lightbox]');
  const dataEl = document.querySelector('[data-hd-lightbox-images]');
  if (!root || !dialog || !dataEl) return;

  let images = [];
  try {
    images = JSON.parse(dataEl.textContent || '[]');
  } catch {
    return;
  }
  if (!images.length) return;

  const stage = dialog.querySelector('[data-hd-lightbox-stage]');
  const img = dialog.querySelector('[data-hd-lightbox-img]');
  const count = dialog.querySelector('[data-hd-lightbox-count]');
  const zoomIn = dialog.querySelector('[data-hd-lightbox-zoom="in"]');
  const zoomOut = dialog.querySelector('[data-hd-lightbox-zoom="out"]');
  const zoomReset = dialog.querySelector('[data-hd-lightbox-zoom="reset"]');
  const prev = dialog.querySelector('[data-hd-lightbox-prev]');
  const next = dialog.querySelector('[data-hd-lightbox-next]');
  if (!stage || !img) return;

  let index = 0;
  let scale = 1;
  let x = 0;
  let y = 0;

  const clampScale = (s) => Math.min(MAX_SCALE, Math.max(MIN_SCALE, s));

  const clampPan = () => {
    const w = img.offsetWidth * scale;
    const h = img.offsetHeight * scale;
    const maxX = Math.max(0, (w - stage.clientWidth) / 2);
    const maxY = Math.max(0, (h - stage.clientHeight) / 2);
    x = Math.min(maxX, Math.max(-maxX, x));
    y = Math.min(maxY, Math.max(-maxY, y));
  };

  const apply = () => {
    if (scale <= MIN_SCALE) {
      scale = MIN_SCALE;
      x = 0;
      y = 0;
    }
    clampPan();
    img.style.transform = `translate(${x}px, ${y}px) scale(${scale})`;
    stage.classList.toggle('is-zoomed', scale > MIN_SCALE);
    if (zoomIn) zoomIn.disabled = scale >= MAX_SCALE;
    if (zoomOut) zoomOut.disabled = scale <= MIN_SCALE;
    if (zoomReset) zoomReset.disabled = scale <= MIN_SCALE;
  };

  // Zoom so the point under (cx, cy) -- measured from the stage centre -- stays put.
  const zoomTo = (target, cx = 0, cy = 0) => {
    const s = clampScale(target);
    const ratio = s / scale;
    x = cx - (cx - x) * ratio;
    y = cy - (cy - y) * ratio;
    scale = s;
    apply();
  };

  const fromCentre = (clientX, clientY) => {
    const rect = stage.getBoundingClientRect();
    return [clientX - rect.left - rect.width / 2, clientY - rect.top - rect.height / 2];
  };

  const show = (i) => {
    index = (i + images.length) % images.length;
    const item = images[index];
    scale = 1;
    x = 0;
    y = 0;
    const done = () => stage.classList.remove('is-loading');
    img.onload = done;
    img.onerror = done;
    // Re-assigning the same URL fires no load event, so only dim the photo
    // while a different one is actually loading.
    if (img.getAttribute('src') !== item.src) {
      stage.classList.add('is-loading');
      img.src = item.src;
    }
    if (img.complete) done();
    img.alt = item.alt || '';
    if (count) count.textContent = images.length > 1 ? `${index + 1} / ${images.length}` : '';
    apply();
  };

  // The expand button sits inside the clickable photo, so one tap reaches
  // both listeners; only the first may open the dialog.
  const open = () => {
    if (dialog.open) return;
    show(Number(root.dataset.hdIndex || 0));
    dialog.showModal();
    document.documentElement.setAttribute('scroll-lock', '');
  };

  root.querySelectorAll('[data-hd-lightbox-open]').forEach((el) => el.addEventListener('click', open));

  dialog.querySelector('[data-hd-lightbox-close]')?.addEventListener('click', () => dialog.close());

  dialog.addEventListener('close', () => {
    document.documentElement.removeAttribute('scroll-lock');
    // Leave the product page showing the photo the shopper ended on.
    const thumb = root.querySelector(`[data-hd-pdp-thumb][data-index="${index}"]`);
    if (thumb && !thumb.classList.contains('is-active')) thumb.click();
  });

  zoomIn?.addEventListener('click', () => zoomTo(scale * STEP));
  zoomOut?.addEventListener('click', () => zoomTo(scale / STEP));
  zoomReset?.addEventListener('click', () => zoomTo(1));
  prev?.addEventListener('click', () => show(index - 1));
  next?.addEventListener('click', () => show(index + 1));

  dialog.addEventListener('keydown', (event) => {
    if (event.key === '+' || event.key === '=') zoomTo(scale * STEP);
    else if (event.key === '-' || event.key === '_') zoomTo(scale / STEP);
    else if (event.key === '0') zoomTo(1);
    else if (event.key === 'ArrowLeft' && images.length > 1) show(index - 1);
    else if (event.key === 'ArrowRight' && images.length > 1) show(index + 1);
    else return;
    event.preventDefault();
  });

  stage.addEventListener(
    'wheel',
    (event) => {
      event.preventDefault();
      const [cx, cy] = fromCentre(event.clientX, event.clientY);
      zoomTo(scale * Math.exp(-event.deltaY * 0.0015), cx, cy);
    },
    { passive: false }
  );

  stage.addEventListener('dblclick', (event) => {
    const [cx, cy] = fromCentre(event.clientX, event.clientY);
    zoomTo(scale > MIN_SCALE ? 1 : DOUBLE_SCALE, cx, cy);
  });

  // Touch and pen: one finger pans a zoomed photo, two fingers pinch, a quick
  // double tap toggles zoom. Mouse drags pan too; mouse double-click is above.
  const pointers = new Map();
  let pinch = null;
  let lastTap = null;
  let moved = false;

  stage.addEventListener('pointerdown', (event) => {
    try {
      stage.setPointerCapture(event.pointerId);
    } catch {
      // Capture is a nicety for drags that leave the stage; gestures work without it.
    }
    pointers.set(event.pointerId, { x: event.clientX, y: event.clientY });
    moved = false;
    if (pointers.size === 2) {
      const [a, b] = [...pointers.values()];
      pinch = { dist: Math.hypot(a.x - b.x, a.y - b.y), scale };
    }
    stage.classList.add('is-dragging');
  });

  stage.addEventListener('pointermove', (event) => {
    const last = pointers.get(event.pointerId);
    if (!last) return;
    const dx = event.clientX - last.x;
    const dy = event.clientY - last.y;
    pointers.set(event.pointerId, { x: event.clientX, y: event.clientY });
    if (Math.abs(dx) + Math.abs(dy) > 2) moved = true;

    if (pointers.size === 2 && pinch) {
      const [a, b] = [...pointers.values()];
      const dist = Math.hypot(a.x - b.x, a.y - b.y);
      const [cx, cy] = fromCentre((a.x + b.x) / 2, (a.y + b.y) / 2);
      if (pinch.dist > 0) zoomTo(pinch.scale * (dist / pinch.dist), cx, cy);
    } else if (pointers.size === 1 && scale > MIN_SCALE) {
      x += dx;
      y += dy;
      apply();
    }
  });

  const release = (event) => {
    if (!pointers.has(event.pointerId)) return;
    pointers.delete(event.pointerId);
    if (pointers.size < 2) pinch = null;
    if (!pointers.size) stage.classList.remove('is-dragging');

    if (event.type === 'pointerup' && event.pointerType !== 'mouse' && !moved && !pointers.size) {
      // Near-misses on the toolbar buttons land at the top of the stage, so
      // taps in that strip never count toward a double-tap, and both taps
      // must land close together.
      const rect = stage.getBoundingClientRect();
      if (event.clientY - rect.top < EDGE_GUARD) {
        lastTap = null;
        return;
      }
      const now = Date.now();
      const near =
        lastTap && Math.hypot(event.clientX - lastTap.x, event.clientY - lastTap.y) < TAP_SLOP;
      if (near && now - lastTap.time < 300) {
        const [cx, cy] = fromCentre(event.clientX, event.clientY);
        zoomTo(scale > MIN_SCALE ? 1 : DOUBLE_SCALE, cx, cy);
        lastTap = null;
      } else {
        lastTap = { x: event.clientX, y: event.clientY, time: now };
      }
    }
  };
  stage.addEventListener('pointerup', release);
  stage.addEventListener('pointercancel', release);

  window.addEventListener('resize', () => {
    if (dialog.open) apply();
  });
}

initLightbox();
